import React, { useEffect, useState, useRef, useContext } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import { CheckSession, FormatCurrency, GetCoockie, GetShoppingCart } from "../../GlobalScript";
import Cookies from 'js-cookie';
import PaginationBar from '../../PaginationBar';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import InputGroup from 'react-bootstrap/InputGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import FooterDealer from '../../FooterDealer.js';
import { ShoppingCartContext } from '../ShoppingCartContext';
import { useTranslation } from 'react-i18next';

export default function AllocatedOrders() {

    const navigate = useNavigate();
    const countPerPage = 25;
    const [pageResults, setPageResults] = useState(countPerPage);
    const [tempPage, setTempPage] = useState(countPerPage);
    const [resultsLength, setResultsLength] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [orderItems, setOrderItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [keyword, setKeyword] = useState('');
    const [status, setStatus] = useState('');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + pageResults;
    /*const currentItems = orderItems.slice(itemOffset, endOffset);*/
    const pageCount = Math.ceil(orderItems.length / pageResults);
    const currentItems = orderItems.slice(itemOffset, endOffset);
    const location = useLocation();
    const [OrderStatusList, setOrderStatusList] = useState(false);
    const { shoppingCart, setShoppingCart } = useContext(ShoppingCartContext);
    const { t } = useTranslation();

    useEffect(() => {
        setShoppingCart(GetShoppingCart(shoppingCart));     
        document.title = `K-Countries - ${t("Navigation.allocatedOrders")}`;
    }, []);

    //useEffect(() => {
    //    if (location.state && location.state.id && location.state.id !== '') {
    //        LoadOrders('', false);
    //    }
    //}, [keyword])

    useEffect(() => {
        if (loading === true) {    
            LoadOrders();
            setLoading(false);
        }
    }, [loading]);

    //useEffect(() => {
    //    if (!OrderStatusList) {
    //        LoadOrderStatusList();
    //    }
    //}, [OrderStatusList]);

    //const LoadOrderStatusList = async () => {
    //    try {
    //        CheckSession();
    //        const response = await fetch("kdealer/GetOrderStatusList");
    //        if (response.status !== 200) {
    //            return;
    //        }
    //        const lst = await response.json();
    //        setOrderStatusList(lst);
    //        console.log(lst)
    //    } catch (e) {
    //        console.log(e);
    //        return;
    //    }
    //}

    const LoadOrders = async () => {
        try {
            CheckSession();
            const user = GetCoockie();
            const data = {
                label: user.userKey.toString(),
                value: user.dealerID
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("kdealer/GetAllocOrders", requestOptions);
            if (response.status !== 200) {
                return;
            }
            const orders = await response.json();
            setOrderItems(orders);
            setResultsLength(orders.length);
        } catch (e) {
            console.log(e);
            return;
        }
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'tempPage') {
            setTempPage(value);
        }
    }

    const handlePageClick = (input) => {
        const pageIndex = typeof input === "number" ? input : input.selected;
        const newOffset = pageIndex * pageResults;
        setCurrentPage(pageIndex);
        setItemOffset(newOffset);
    };

    const changePageResults = () => {
        if (tempPage && tempPage > 0 && tempPage < 1000) {
            const newSize = Number(tempPage) || 1; // basic safety 
            setPageResults(newSize);
            setCurrentPage(0);
            setItemOffset(0);
        }
    };

    return (
        <>
            <Container className="checkout-container main-container dealer-section min-height-spacing-lg">

                <Row className="help-title-row checkout-title-row">
                    <Col className="help-center-title checkout-title">
                        <h1 className="heading help-heading">{t("Navigation.Allocated Orders")}</h1>
                    </Col>
                    <Col className="checkout-title-under"></Col>
                </Row>

                {/*<Row>*/}
                {/*    <Col sm={12}>*/}
                {/*        <Card>*/}
                {/*            <Card.Body>*/}
                {/*                <Row>*/}
                {/*                    <Col sm={3}>*/}
                {/*                        <FloatingLabel label="Keyword" className="mb-4">*/}
                {/*                            <Form.Control id="keyword" type="text" placeholder="Keyword" value={keyword} className={'form-control'} onChange={handleChange} name="keyword" />*/}
                {/*                        </FloatingLabel>*/}
                {/*                    </Col>*/}
                {/*                    <Col sm={3}>*/}
                {/*                        <Form.Select aria-label="Status" onChange={handleChange} value={status} name="status" className="tall-select">*/}
                {/*                            <option value={''}>All</option>*/}
                {/*                            {*/}
                {/*                                OrderStatusList && OrderStatusList.map((item, index) => (*/}
                {/*                                    <option key={item.value} value={item.value}>{item.label}</option>*/}
                {/*                                ))*/}
                {/*                            }*/}
                {/*                        </Form.Select>*/}
                {/*                    </Col>*/}
                {/*                    <Col sm={3}>*/}
                {/*                        <FloatingLabel label="Date From" className="mb-4">*/}
                {/*                            <Form.Control id="dateFrom" type="text" placeholder="Date From" value={dateFrom} className={'form-control'} onChange={handleChange} name="dateFrom" />*/}
                {/*                        </FloatingLabel>*/}
                {/*                    </Col>*/}
                {/*                    <Col sm={3}>*/}
                {/*                        <FloatingLabel label="Date To" className="mb-4">*/}
                {/*                            <Form.Control id="dateTo" type="text" placeholder="Date To" value={dateTo} className={'form-control'} onChange={handleChange} name="dateTo" />*/}
                {/*                        </FloatingLabel>*/}
                {/*                    </Col>*/}

                {/*                    <Col sm={{ offset: 8 }} className="text-right" style={{ alignSelf: 'center' }}>*/}
                {/*                        <p className="clickable underline green-text" onClick={ResetSearch }>Reset Search</p>*/}
                {/*                    </Col>*/}

                {/*                    <Col className="text-center mb-3">*/}
                {/*                        <Button variant="secondary"  onClick={handleSearchClick}>*/}
                {/*                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">*/}
                {/*                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />*/}
                {/*                            </svg>*/}
                {/*                            SEARCH*/}
                {/*                        </Button>*/}
                {/*                    </Col>*/}
                {/*                </Row>*/}
                {/*            </Card.Body>*/}
                {/*        </Card>*/}
                {/*    </Col>*/}
                {/*</Row>*/}

                <Row className="mt-4 mb-4">
                    <Col sm={12}>
                        <Card className="">
                            <Card.Body>
                                {/*<Row className="table-legend text-center">*/}
                                {/*    <Col sm={12}>*/}
                                {/*        <div className="table-legend-section">*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/parts.svg" alt="" className="" /> Parts</span>*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/accessories.svg" alt="" className="" /> Accessories</span>*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/other.svg" alt="" className="" /> Other</span>*/}
                                {/*        </div>*/}
                                {/*        <div className="table-legend-section">*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/partially-shipped.svg" alt="" className="" /> Partially Shipped</span>*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/shipped-active.svg" alt="" className="" /> Shipped</span>*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/returned.svg" alt="" className="" /> Returned</span>*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/queued.svg" alt="" className="" /> Queued</span>*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/cancelled-inactive.svg" alt="" className="" /> Cancelled</span>*/}
                                {/*        </div>*/}
                                {/*        <div className="table-legend-section">*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/backorder.svg" alt="" className="" /> Backorder</span>*/}
                                {/*        </div>*/}
                                {/*    </Col>*/}
                                {/*</Row>*/}

                                <PaginationBar
                                    resultsLength={resultsLength}
                                    pageCount={pageCount}
                                    currentPage={currentPage}
                                    pageResults={pageResults}
                                    tempPage={tempPage}
                                    onTempPageChange={handleChange}
                                    onPageResultsChange={changePageResults}
                                    onPageChange={handlePageClick}
                                />

                                <Row>
                                    <Col sm={12} className="order-table">
                                        <Table hover responsive>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>METODO <br /> DE LA NAVE</th>
                                                    <th>CODIGO DE ALMACEN</th>
                                                    <th>CUST ORDEN <br /> PP.</th>
                                                    <th>KMC ORDEN <br /> PP.</th>
                                                    <th>MEMO <br /> DEALER</th>
                                                    <th>CUST ORDER <br /> LINE PP.</th>
                                                    <th>NUMERO DEL <br /> ARTICULO</th>
                                                    <th>CONDE <br /> NUMERADO</th>
                                                    <th>ASIGNADA <br /> FECHA</th>
                                                    <th>FOB <br /> AMPLIADA</th>
                                                    <th>PESO <br /> (GRAMOS)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                
                                                {currentItems && currentItems.map((item, index) => (
                                                    <tr className="" key={"item" + index}>
                                                        <td>{(currentPage * pageResults) + index + 1}</td>
                                                        <td>{item.shipCode}</td>
                                                        <td>{item.whseCode}</td>
                                                        <td className="bold">{item.kmcOrdNbr}</td>
                                                        <td>{item.kmcOrdNbr}</td>
                                                        <td>{item.commentTxt}</td>
                                                        <td>{item.itemNbr}</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>{item.orderDate}</td>
                                                        <td></td>
                                                        <td>{item.weightCnt}</td>
                                                    </tr>
                                                ))}
                                             
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>

                                <PaginationBar
                                    resultsLength={resultsLength}
                                    pageCount={pageCount}
                                    currentPage={currentPage}
                                    pageResults={pageResults}
                                    tempPage={tempPage}
                                    onTempPageChange={handleChange}
                                    onPageResultsChange={changePageResults}
                                    onPageChange={handlePageClick}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

            </Container>

            <FooterDealer />
        </>
    );
}